import { SET_SKELETON } from '@actions/skeletonActions'

export interface SkeletonAction {
  type: string
  payload: {
    show: boolean
  }
}

const initialState = {
  show: false,
}

export default function skeletonReducer(state = initialState, action: SkeletonAction) {
  if (action.type === SET_SKELETON) {
    return {
      ...state,
      show: action.payload.show,
    }
  } else {
    return state
  }
}
